import * as React from "react";
import { Page, Card, Button, Table, Grid, Form, Icon } from "tabler-react";
import Paginate from "../../components/Paginate";
import { formatCurrency } from '../../store/ViewStore/Utils'

class PageGrid extends React.Component {
    render() {
        const rows = this.props.store.rows.map((row, i) => (
            <Table.Row key={i} className="myList">
                <Table.Col>
                    {row.simbolo}
                </Table.Col>
                <Table.Col>
                    {formatCurrency(row.remuneracao, 'pt-BR', 'BRL')}
                </Table.Col>
                <Table.Col alignContent="center">
                    <Icon link name="edit" onClick={() => this.props.showForm(row.id)} />
                    <Icon link name="trash-2" onClick={() => this.props.onDelete(row.id)} />
                </Table.Col>
            </Table.Row>
        ));

        const noRows = (
            <Table.Row className="myList">
                <Table.Col colSpan={3} alignContent="center">
                    0 registros foram localizados
                </Table.Col>
            </Table.Row>
        );

        return (
            <Page.Content>
                <Page.Header>
                    <Page.Title>
                        <Grid.Row>
                            <Grid.Col md={6}>
                                Cargos
                                </Grid.Col>
                            <Grid.Col md={2}>

                                <Button
                                    onClick={() => this.props.showForm()}
                                    color="cyan"
                                    icon="plus">
                                    Novo registro
                                </Button>

                            </Grid.Col>

                        </Grid.Row>
                    </Page.Title>
                </Page.Header>

                <Card
                    body={(
                        <Grid.Row>
                            <Grid.Col>
                                <Grid.Row>
                                    <Grid.Col md={12}>
                                        <Form.Group label="Simbologia">
                                            <Form.Input name="simbolo"
                                                type="text"
                                                defaultValue={this.props.store.simbolo}
                                                onChange={e => this.props.store.onChangeSimbolo(e.target.value)} />
                                        </Form.Group>
                                    </Grid.Col>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Col width={2}>
                                        <Button
                                            type='button'
                                            value='button'
                                            onClick={() => this.props.onChangePage(1)}
                                            color="cyan">
                                            Pesquisar
                                        </Button>
                                    </Grid.Col>
                                </Grid.Row>
                            </Grid.Col>
                        </Grid.Row>
                    )}>

                </Card>
                <Card>
                    <Table
                        responsive
                        highlightRowOnHover
                        hasOutline
                        verticalAlign="center"
                        cards
                        className="text-nowrap"

                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.ColHeader>Simbologia</Table.ColHeader>
                                <Table.ColHeader>Remuneração</Table.ColHeader>
                                <Table.ColHeader alignContent="center">Ações</Table.ColHeader>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {rows.length > 0 ? rows : noRows}
                            <Table.Row>
                                <Table.Col colSpan={3}>
                                    <Paginate
                                        rowsCount={this.props.store.rowsCount}
                                        limit={this.props.store.limit}
                                        currentPage={this.props.store.page}
                                        onChangePage={this.props.onChangePage} />
                                </Table.Col>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                </Card>
            </Page.Content>
        );
    }
}

export default PageGrid;